import { T } from "../constants/theme";

export default function Badge({
  children,
  color = T.saffron,
}) {
  return (
    <span
      style={{
        background: color + "18",
        color,
        fontSize: 12,
        fontWeight: 700,
        padding: "2px 9px",
        borderRadius: 99,
        letterSpacing: "0.03em",
      }}
    >
      {children}
    </span>
  );
}